import useNavigator from "@dashboard/hooks/useNavigator";
import { productUrl, productVariantEditUrl } from "@dashboard/products/urls";
import { Button } from "@saleor/macaw-ui";
import { Box } from "@saleor/macaw-ui-next";
import noop from "lodash/noop";
import React from "react";
import { FormattedMessage } from "react-intl";

import { ProductVariantsHeader } from "../ProductVariants/components/ProductVariantsHeader";
import messages from "./messages";

interface ProductVariantsProps {
  productId: string;
  defaultVariantId: string | undefined;
}

export const ProductVariantsHidden: React.FC<ProductVariantsProps> = ({
  productId,
  defaultVariantId,
}) => {
  const navigate = useNavigator();

  return (
    <Box>
      <ProductVariantsHeader
        productId={productId}
        productName=""
        addRowOnDatagrid={noop}
        isAnimationOpenFinished={false}
        isFullscreenOpen={false}
        toggleFullscreen={undefined}
      />

      <Box display="flex" flexDirection="row" gap={4} justifyContent="center">
        <Button
          href={productUrl(productId, { showVariants: true })}
          onClick={e => {
            e.preventDefault();
            navigate(productUrl(productId, { showVariants: true }));
          }}
          variant="primary"
        >
          <FormattedMessage {...messages.displayVariants} />
        </Button>

        {defaultVariantId && (
          <Button
            href={productVariantEditUrl(productId, defaultVariantId)}
            onClick={e => {
              e.preventDefault();
              navigate(productVariantEditUrl(productId, defaultVariantId));
            }}
          >
            <FormattedMessage {...messages.goToDefaultVariant} />
          </Button>
        )}
      </Box>
    </Box>
  );
};
ProductVariantsHidden.displayName = "ProductVariants";
export default ProductVariantsHidden;
